<div class="container" *ngIf="notificationGroups$ | async as groups">
  <div class="card-columns">
    <ng-container *ngFor="let group of groups; trackBy: trackGroup">
      <fgb-notification-group-item [group]="group"></fgb-notification-group-item>
    </ng-container>
  </div>
</div>
